import { useEffect, useState } from 'react'
export default function DateOfDay(prop: any) {
   const { format } = prop
   const [date, setDate] = useState('')
   const [time, setTime] = useState('')
   const loadDate = () => {
      const newDate = new Date()
      const minute = newDate.getMinutes()
      const hour = newDate.getHours()
      const options: any = { day: 'numeric', month: 'numeric', year: '2-digit' }
      setTime((hour < 10 ? '0' : '') + hour + ':' + (minute < 10 ? '0' : '') + minute)
      format != 'en'
         ? setDate(newDate.toLocaleDateString('fr', options))
         : setDate(newDate.toLocaleDateString('en-US', options))
   }
   useEffect(() => {
      loadDate()
      const interval = setInterval(() => {
         loadDate()
      }, 10000)

      return () => {
         clearInterval(interval)
      }
   }, [format])
   return (
      <div id='day' className='flex column center'>
         <div id='hour'>{time}</div>
         <div id='date'>{date}</div>
      </div>
   )
}
